import { EwMaImageService } from './../../ew-ma-image.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthenticationService, statusCodes } from 'ew-common-lib';
@Component({
  selector: 'lib-my-images',
  templateUrl: './my-images.component.html',
  styleUrls: ['./my-images.component.css'],
})
export class MyImagesComponent implements OnInit {
  /**
   * @description
   * User domian value from Auth service.
   */
  private userDomain: string;

  public showLoader: boolean = false;
  public images = [];
  public accepts = 'image/png,image/jpeg,image/jpg,image/gif';
  public maxFileSize = 10485760; // 10 MB
  selectedIndex: number = null;
  /**
   * @description
   * Event id value from EwMaImageService service.
   */
  private eventId: string;

  public searchQuery: string = '';
  public page: number = 1;
  public limit: number = 10;
  public totalItems: number = 0;
  public noImagesIconPath = "";
  /**
   * @description
   * Emit event to close dialog.
   */
  @Output() selectedImage: EventEmitter<any> = new EventEmitter();
  @Output() loaderShown: EventEmitter<any> = new EventEmitter();

  constructor(
    private ewMaImageService: EwMaImageService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.userDomain = this.authenticationService.getUserDomain();
    this.eventId = this.ewMaImageService.eventId;
    this.getImages(1);
    this.loaderShown.emit(this.showLoader);
    this.noImagesIconPath = this.ewMaImageService.getResourceUrl("assets/images/Property-default.svg");
  }

  onSelect(event: any) {
    if (event.addedFiles.length) {
      this.showLoader = true;
      this.loaderShown.emit(this.showLoader);
      let file = event.addedFiles[0];
      let fileName = file.name.replace(/\s/g, '-');
      this.uploadObject(fileName, file, 'public-read');
    } else {
      console.log('Invalid file');
    }
  }

  public uploadObject(key: string, file: File, access: string) {
    let self = this;
    let uniqueFileName = Date.now() + key;
    let finalUrl = this.ewMaImageService.getS3BucketUrl() + uniqueFileName;
    let data = {
      ReqMethod: 'putObject',
      FileName: uniqueFileName,
      ContentType: file.type,
      ACL: access,
      domain_id: this.userDomain,
    };
    let imageMeta = { width: 0, height: 0, size: 0 };
    this.ewMaImageService.getImageMeta(file).then((result: any) => {
      imageMeta = result;
    });

    this.ewMaImageService.getSignedAWSResponseUrl(data).subscribe(
      (res) => {
        // if (res.status.code == statusCodes.SUCCESS) {
        //   this.ewMaImageService.uploadAWSObject(res.data.url, file).subscribe(

        if (res.status == statusCodes.SUCCESS) {
            this.ewMaImageService.uploadAWSObject(res.url, file).subscribe(

            (res) => {
              const finalImageData = {
                image_name: key,
                image_width: imageMeta.width,
                image_height: imageMeta.height,
                image_size: imageMeta.size,
                image_url: finalUrl,
                image_type: 'offer',
              };
              self.addImage(finalImageData);
            },
            (error) => {
              console.log('error', error);
              self.showLoader = false;
              this.loaderShown.emit(self.showLoader);
            }
          );
        }
      },
      (error) => {
        self.showLoader = false;
        this.loaderShown.emit(self.showLoader);
      }
    );
  }

  addImage(data: any) {
    data.domain_id = this.userDomain;
    data.event_id = this.eventId;
    this.ewMaImageService.addImage(data).subscribe(
      (response: any) => {
        if (response.status.code == statusCodes.RECORD_CREATED) {
          this.searchQuery = "";
          this.getImages(1);
        } else {
          console.log('Error in api request');
        }
      },
      (error) => {
        console.log('error', error);
      }
    );
  }

  /**
   * @description
   * Get upcoming sessions list
   */
  getImages(page: number) {
    this.showLoader = true;
    this.loaderShown.emit(this.showLoader);
    this.page = page;
    const model = {
      domain_id: this.userDomain,
      event_id: this.eventId,
      page: page,
      limit: this.limit,
      search_item: ''
    };
    if (this.searchQuery.length) {
      model.search_item = this.searchQuery;
    }
    console.log(model);
    this.ewMaImageService.getImages(model).subscribe(
      (response: any) => {

        this.showLoader = false;
        this.loaderShown.emit(this.showLoader);
        if (response.status.code == statusCodes.SUCCESS) {
          this.images = response.data.records;
          this.totalItems = response.data.pagination.total_records;
        } else {
          console.log('Error in api request');
          this.resetRecords();
        }
      },
      (error) => {
        this.showLoader=false
        console.log('error', error);
        this.resetRecords();
      }
    );
  }

  resetRecords() {
    this.page = 1;
    this.images = [];
    this.totalItems = 0;
  }

  selectImage(image: any, index: number) {
    image.active = !image.active;
    this.selectedIndex = index;
    this.selectedImage.emit(image);
  }

  getImageHeight(properties) {
    properties = JSON.parse(properties);
    return properties.image_height;
  }

  getImageWidth(properties) {
    properties = JSON.parse(properties);
    return properties.image_width;
  }

  searchImage(search: string) {
    this.searchQuery = search;
    this.getImages(1);
  }

  resetSearch(search: string){
    if(search.length == 0){
      this.getImages(1);
    }
  }
}
